module.exports = __webpack_public_path__ + "img/a45632b.jpg";